import React from 'react';
import { useApp } from '../../context/AppContext';
import type { Screen } from '../../types';

const MOBILE_NAV = [
  { id: 'home',      icon: 'ti-home',                   label: 'Home'     },
  { id: 'leads',     icon: 'ti-user-bolt',              label: 'Leads', badge: '6', badgeRed: true },
  { id: 'admin',     icon: 'ti-files',                  label: 'Library'  },
  { id: 'analytics', icon: 'ti-chart-bar',              label: 'Analytics'},
  { id: 'more',      icon: 'ti-dots',                   label: 'More'     },
];

// "More" screens shown in a sheet
const MORE_NAV = [
  { id: 'dealrooms', icon: 'ti-building',               label: 'Deal Rooms'   },
  { id: 'demohub',   icon: 'ti-presentation-analytics', label: 'Demo Hub'     },
  { id: 'tracking',  icon: 'ti-broadcast',              label: 'Live Tracking', badge: '2' },
  { id: 'client',    icon: 'ti-eye',                    label: 'Buyer View'   },
  { id: 'team',      icon: 'ti-users',                  label: 'Team'         },
];

export default function MobileNav() {
  const { screen, go, currentUser, logout } = useApp();
  const [showMore, setShowMore] = React.useState(false);

  const activeInMore = MORE_NAV.some(n => n.id === screen);

  return (
    <>
      {/* Bottom tab bar */}
      <div style={{
        position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 200,
        background: '#0F1B2D',
        borderTop: '1px solid rgba(255,255,255,.1)',
        display: 'flex',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}>
        {MOBILE_NAV.map(item => {
          const isActive = (item.id === 'more' ? activeInMore || showMore : screen === item.id);
          return (
            <button
              key={item.id}
              onClick={() => {
                if (item.id === 'more') { setShowMore(p => !p); }
                else { go(item.id as Screen); setShowMore(false); }
              }}
              style={{
                flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
                justifyContent: 'center', gap: '3px', padding: '10px 4px 8px',
                background: 'none', border: 'none', cursor: 'pointer',
                color: isActive ? '#E8B55A' : 'rgba(255,255,255,.5)',
                fontFamily: 'inherit', position: 'relative',
              }}
            >
              {isActive && (
                <span style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: '24px', height: '2px', background: '#C8973A', borderRadius: '0 0 3px 3px' }} />
              )}
              {item.badge && (
                <span style={{ position: 'absolute', top: '6px', right: '50%', transform: 'translateX(8px)', background: item.badgeRed ? '#EF4444' : '#C8973A', color: 'white', fontSize: '8px', fontWeight: '700', borderRadius: '20px', padding: '1px 5px', lineHeight: '12px' }}>
                  {item.badge}
                </span>
              )}
              <i className={`ti ${item.icon}`} style={{ fontSize: '20px' }} />
              <span style={{ fontSize: '9px', fontWeight: '600', letterSpacing: '.02em' }}>{item.label}</span>
            </button>
          );
        })}
      </div>

      {/* More sheet */}
      {showMore && (
        <>
          <div style={{ position: 'fixed', inset: 0, zIndex: 198, background: 'rgba(0,0,0,.5)' }} onClick={() => setShowMore(false)} />
          <div style={{
            position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 199,
            background: '#0F1B2D', borderRadius: '20px 20px 0 0',
            padding: '12px 0 calc(80px + env(safe-area-inset-bottom))',
            boxShadow: '0 -8px 40px rgba(0,0,0,.4)',
          }}>
            {/* Handle */}
            <div style={{ width: '36px', height: '4px', borderRadius: '2px', background: 'rgba(255,255,255,.2)', margin: '0 auto 16px' }} />
            <div style={{ padding: '0 6px' }}>
              {MORE_NAV.map(item => (
                <button key={item.id} onClick={() => { go(item.id as Screen); setShowMore(false); }}
                  style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px', background: screen === item.id ? 'rgba(200,151,58,.15)' : 'none', border: 'none', borderRadius: '10px', cursor: 'pointer', color: screen === item.id ? '#E8B55A' : 'rgba(255,255,255,.8)', fontFamily: 'inherit', fontSize: '14px', fontWeight: '500', marginBottom: '2px' }}>
                  <i className={`ti ${item.icon}`} style={{ fontSize: '20px', width: '24px' }} />
                  <span style={{ flex: 1, textAlign: 'left' }}>{item.label}</span>
                  {item.badge && <span style={{ background: '#C8973A', color: '#0F1B2D', fontSize: '10px', fontWeight: '700', borderRadius: '20px', padding: '2px 8px' }}>{item.badge}</span>}
                  {screen === item.id && <i className="ti ti-check" style={{ fontSize: '14px', color: '#C8973A' }} />}
                </button>
              ))}
            </div>
            {/* User row */}
            <div style={{ margin: '12px 22px 0', paddingTop: '12px', borderTop: '1px solid rgba(255,255,255,.08)', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ width: '34px', height: '34px', borderRadius: '50%', background: '#C8973A', color: '#0F1B2D', fontSize: '12px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{currentUser?.ini}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '13px', fontWeight: '600', color: 'white' }}>{currentUser?.name}</div>
                <div style={{ fontSize: '11px', color: 'rgba(255,255,255,.4)' }}>{currentUser?.role}</div>
              </div>
              <button onClick={() => { logout(); setShowMore(false); }} style={{ padding: '6px 12px', borderRadius: '8px', background: 'rgba(255,255,255,.08)', border: 'none', color: 'rgba(255,255,255,.7)', fontFamily: 'inherit', fontSize: '12px', cursor: 'pointer' }}>
                Sign out
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}
